import { createAction } from '@reduxjs/toolkit';
import { RecordOf } from 'immutable';
import { getPayloadCreator } from '../core/actionHelpers';
import { QcsSyncResourcesPayloadProps } from '../core/resourceStoreTypes';
import { Account, AccountProps } from './accountsTypes';

const payloadCreator = getPayloadCreator<Account>();
const syncAccountPayloadCreator = getPayloadCreator<RecordOf<QcsSyncResourcesPayloadProps<AccountProps>>>();
const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const accountsPayloadCreator = getPayloadCreator<Account[]>();
const accountActionPayloadCreator = getPayloadCreator<{ id: string; qcsAction: string }>(); // TODO: Types for all valid actions?

export const getAccounts = createAction('GET_ACCOUNTS', getPayloadCreator());
export const getAccountsSuccess = createAction('GET_ACCOUNTS_SUCCESS', syncAccountPayloadCreator);
export const getAccountsFailure = createAction('GET_ACCOUNTS_FAILURE', errorPayloadCreator);

export const createAccount = createAction('CREATE_ACCOUNT', payloadCreator);
export const createAccountSuccess = createAction('CREATE_ACCOUNT_SUCCESS', payloadCreator);
export const createAccountFailure = createAction('CREATE_ACCOUNT_FAILURE', errorPayloadCreator);

export const updateAccount = createAction('UPDATE_ACCOUNT', payloadCreator);
export const updateAccountSuccess = createAction('UPDATE_ACCOUNT_SUCCESS', payloadCreator);
export const updateAccountFailure = createAction('UPDATE_ACCOUNT_FAILURE', errorPayloadCreator);

export const deleteAccount = createAction('DELETE_ACCOUNT', payloadCreator);
export const deleteAccountSuccess = createAction('DELETE_ACCOUNT_SUCCESS', payloadCreator);
export const deleteAccountFailure = createAction('DELETE_ACCOUNT_FAILURE', errorPayloadCreator);

export const batchAccounts = createAction('BATCH_ACCOUNTS', accountsPayloadCreator);
export const batchAccountsSuccess = createAction('BATCH_ACCOUNTS_SUCCESS', accountsPayloadCreator);
export const batchAccountsFailure = createAction('BATCH_ACCOUNTS_FAILURE', accountsPayloadCreator);

export const applyAccountsChanges = createAction('APPLY_ACCOUNTS_CHANGES', accountsPayloadCreator);

export const performAccountAction = createAction('PERFORM_ACCOUNT_ACTION', accountActionPayloadCreator);
export const performAccountActionSuccess = createAction('PERFORM_ACCOUNT_ACTION_SUCCESS', payloadCreator);
export const performAccountActionFailure = createAction('PERFORM_ACCOUNT_ACTION_FAILURE', errorPayloadCreator);
